const HexTileTypeList = ['default', 'water', 'forest', 'field', 'beach'] as const;
type HexTileType = (typeof HexTileTypeList)[number];

type HexTileCoordinates = {
  q: number;
  r: number;
};

interface HexTileProperties {
  type: HexTileType;
  resourceValue: number;
  coordinates: HexTileCoordinates;
}

interface HexMapProperties {
  tiles: HexTileMap;
}

type CartesianCoordinates = {
  x: number;
  y: number;
  z: number;
};

type HexTileMapKey = `${HexTileCoordinates['q']},${HexTileCoordinates['r']}`;

type HexTileMap = Map<HexTileMapKey, HexTileProperties>;

export type {
  CartesianCoordinates,
  HexMapProperties,
  HexTileCoordinates,
  HexTileMap,
  HexTileMapKey,
  HexTileProperties,
  HexTileType,
};

export { HexTileTypeList };
